import React, { useEffect } from 'react';
import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import SingleCSP from './SingleCSP';
import { ChargeableWeight, TableHeader } from './styles';
import Actions from './Actions';
import SingleCSPMobile from './SingleCSPMobile';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootStateType } from '../../../store';
import { HandleBookCSPType } from '../../../store/reducers/GetRates/Type';
import { getWarehouseListForShipment } from '@Reducers/Warehouse';
import { getSpecificWarehouseListForShipment } from '@Reducers/Warehouse/actions';
import { userLogin } from '@Services/hasAdminAccess';

interface PropsType {
  weightUnit: string;
  setShowRates?: (show: boolean) => void;
  handleBookCSP: HandleBookCSPType;
}

function CSPList({ /*weightUnit,*/ setShowRates, handleBookCSP }: PropsType) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const dispatch = useDispatch<AppDispatch>();
  const CSPChargesData = useSelector((state: RootStateType) => state?.getRates?.CSPChargesData);
  const organizationData = useSelector((state: RootStateType) => state.orgSetup.organizationPublicData);
  const { name = '' } = organizationData || {};
  const accountNumber = useSelector((state: RootStateType) => state?.loginUser?.profile?.accountNumber) || '';
  const isUserLogin = userLogin();
  const { CreateShipment } = useSelector((state: RootStateType) => state.accountLookup);

  useEffect(() => {
    if (name === 'Cargo Solutions Network') {
      dispatch(getWarehouseListForShipment());
      dispatch(
        getSpecificWarehouseListForShipment(
          isUserLogin
            ? accountNumber
            : CreateShipment?.selectedUser?.accountNumber || CreateShipment?.selectedUser?._accountId?.accountNumber,
        ),
      );
    }
  }, [dispatch]);

  const hurricaneData = CSPChargesData?.hurricaneData;
  const showDutyTaxColumn = !!(
    hurricaneData &&
    ((hurricaneData.duty && typeof hurricaneData.duty.amount === 'number') ||
      (hurricaneData.tax && typeof hurricaneData.tax.amount === 'number'))
  );

  const dutyChargeAmount = CSPChargesData?.dutyChargeAmount;

  return (
    <Grid container item sx={{ padding: { xs: '0 1.5rem', sm: '0 3rem' } }}>
      <Grid container className="mb-1" alignItems="center">
        <Grid item xs={6}>
          <Typography className="org-text">Services Available</Typography>
        </Grid>
        <Grid container item xs={6} justifyContent="end">
          <ChargeableWeight>{`Chargeable Weight: ${CSPChargesData?.chargeableWeight}`}</ChargeableWeight>
        </Grid>
      </Grid>
      <Grid container>
        {!isMobile && (
          <TableHeader
            item
            xs={12}
            sx={{
              display: 'grid',
              gridTemplateColumns: showDutyTaxColumn
                ? '83px 1fr 110px 150px 130px 130px'
                : '83px 1fr 110px 150px 130px',
              alignItems: 'center',
              columnGap: '16px',
              boxSizing: 'border-box',
              padding: '0 24px',
              height: '40px',
              width: '100%',
            }}
          >
            <Grid item /> {/* Logo placeholder */}
            <Grid item className="sm-text">
              Carrier
            </Grid>
            <Grid item className="sm-text" sx={{ textAlign: 'center' }}>
              Chargeable Wt
            </Grid>
            <Grid item className="sm-text" sx={{ textAlign: 'center' }}>
              Cost
            </Grid>
            {showDutyTaxColumn && (
              <Grid item className="sm-text" sx={{ textAlign: 'center' }}>
                Duty + Tax
              </Grid>
            )}
            <Grid item /> {/* Action placeholder */}
          </TableHeader>
        )}
        {CSPChargesData?.charges?.map((charge, ind) =>
          isMobile ? (
            <SingleCSPMobile
              key={ind}
              CSPCharge={charge}
              handleBookCSP={handleBookCSP}
              hurricaneData={hurricaneData}
              dutyChargeAmount={dutyChargeAmount}
            />
          ) : (
            <SingleCSP
              key={ind}
              CSPCharge={charge}
              handleBookCSP={handleBookCSP}
              hurricaneData={hurricaneData}
              dutyChargeAmount={dutyChargeAmount}
            />
          ),
        )}
      </Grid>
      <Actions setShowRates={setShowRates} />
    </Grid>
  );
}

export default CSPList;
